<template>
	<div class="row">
		<div class="col-12">
			<div class="card mb-2">
				<div class="card-body pb-0">
					<div class="row">
						<div class="col-6 col-lg-2 mb-3">
							<label><i class="far fa-filter font-13 color-theme mr-1 cursor-pointer"></i> Filtro</label>
							<v-select title="Desktop" :options="['Nome','CPF','Agendamento',]" v-model="pesquisa.tipo" class="rounded"/>
							<select title="Mobile" class="form-control rounded" v-model="pesquisa.tipo">
								<option v-for="(option, index) in ['Nome','CPF','Agendamento',]" :key="index" :value="option">{{ option }}</option>
							</select>
						</div>

						<div class="col-6 col-lg-2 mb-3">
							<label><i class="far fa-filter font-13 color-theme mr-1 cursor-pointer"></i> Direcionado</label>
							<v-select title="Desktop" :options="['Todos', 'Aluno (a)', 'Comunidade', 'Diretor (a)', 'Vice-diretor (a)', 'Pedagogo (a)', 'Professor (a)', 'Estagiário (a)', 'Zelador (a)','Merendeira', 'Segurança']" v-model="pesquisa.direcionado" class="rounded"/>
							<select title="Mobile" class="form-control rounded" v-model="pesquisa.direcionado">
								<option v-for="(option, index) in ['Todos', 'Aluno (a)', 'Comunidade', 'Diretor (a)', 'Vice-diretor (a)', 'Pedagogo (a)', 'Professor (a)', 'Estagiário (a)', 'Zelador (a)','Merendeira', 'Segurança']" :key="index" :value="option">{{ option }}</option>
							</select>
						</div>

						<div class="col-10 col-lg-7 mb-3" v-if="pesquisa.tipo == 'Agendamento'">
							<label><i class="far fa-filter font-13 color-theme mr-1 cursor-pointer"></i> Data</label>
							<input class="form-control rounded" type="date" v-model="pesquisa.data" />
						</div>

						<div class="col-10 col-lg-7 mb-3" v-else>
							<label><i class="far fa-filter font-13 color-theme mr-1 cursor-pointer"></i> Nome</label>
							<input type="text" class="form-control rounded" v-model="pesquisa.valor" maxlength="200" placeholder="Digite aqui" />
						</div>

						<div class="col-2 col-lg-1 align-self-end mb-3">
							<button class=" btn btn-secondary w-100 rounded" @click="pesquisarUsuario(0)">
								<i class="fa fa-search font-13"></i>
							</button>
						</div>
					</div>
				</div>

				<div class="d-flex justify-content-center mb-1 font-italic font-14">
					<span v-if="numeroResultados == 1">{{numeroResultados + ' resultado encontrado'}}</span>
					<span v-else-if="numeroResultados > 1">{{listaAlunos.length + ' de ' + numeroResultados + ' resultados encontrados'}}</span>
				</div>
			</div>
		</div>

		<!-- Resultado da pesquisa -->
		<div class="col-12">
			<div v-if="listaAlunos.length > 0">
				<div class="row">
					<aluno v-for="(aluno, index) in listaAlunos" :key="index" :index="index" :aluno="aluno" @abrir="abrirAluno($event)" @deleteAluno="deletarAluno($event)"/>
				</div>
			</div>

			<div class="col-12 my-5 text-center font-16" v-else>Nenhum aluno encontrado</div>
			
			<div class="d-flex justify-content-center mt-3" v-if="numeroResultados > listaAlunos.length">
				<button class="btn btn-primary rounded mb-3" title="Carregar mais cadastros" @click="pesquisarUsuario(null)">
					<span>Ver mais</span>
				</button>
			</div>
		</div>

		<!-- modal perfil -->
		<div class="modal fade" id="modalPerfil" tabindex="-1" aria-labelledby="modalPerfilLabel" data-backdrop="static" data-keyboard="false" aria-hidden="true">
			<div class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title h4 color-theme"><span class="font-17">Perfil</span></h5>
						<button type="button" class="close text-danger" data-dismiss="modal"  @click="fecharPerfil"><span aria-hidden="true">×</span></button>
					</div>
					<div class="modal-body mb-0">
						<div class="row mb-0">
							<div class="card mb-0 p-2">
								<div class="d-flex justify-content-between">
									<div class="p-1" v-if="aluno != null">
										<span class="unicoLimitador font-16 font-weight-bold d-block">{{aluno.nomeCompleto}}</span>
										<span class="unicoLimitador font-15 d-block">
											<span class="color-theme mr-1">Capelão:</span>{{aluno.nomeAdm}}
										</span>
										<span class="unicoLimitador font-14 d-block">
											<span class="color-theme mr-1">Agenda:</span>{{aluno.dataAgendamento == null ? 'Sem agendamento' : new Date(aluno.dataAgendamento).toLocaleString('pt-br', {minimumFractionDigits: 1, maximumFractionDigits:1, year: 'numeric', month: 'numeric', day: 'numeric'}) }} {{aluno.dataAgendamento == null ? '' : '| ' + new Date(aluno.dataAgendamento).toLocaleString('pt-br', {minimumFractionDigits: 1, maximumFractionDigits:1, hour: 'numeric', minute: 'numeric',hour12: false}) }}
										</span>
										<span class="unicoLimitador font-14 d-block">
											<span class="color-theme mr-1">Nível:</span>{{aluno.nivel}} pontos
										</span>
									</div>
									<div class="d-flex">
										<div class=" d-flex mr-2">
											<div class="d-flex flex-column justify-content-center">
												<button title="Pós cadastro" class="btn btnPanel mb-1 rounded" @click="posCadastro(aluno)">
													<i class="far fa-file-alt iconPanel font-13"></i>
												</button>
												<button title="Transferência" class="btn btnPanel mt-1 rounded" @click="modalConfig.transferencia = !modalConfig.transferencia">
													<i class="fas fa-people-arrows iconPanel font-13"></i>
												</button>
											</div>
										</div>
										<div class=" d-flex mr-2">
											<div class="d-flex flex-column justify-content-center">
												<button title="Editar" class="btn btnPanel mb-1 rounded" @click="abrirEditar(aluno)">
													<i class="far fa-pen iconPanel font-13"></i>
												</button>
												<button title="Agenda" class="btn btnPanel mt-1 rounded" @click="modalConfig.agendamento = !modalConfig.agendamento">
													<i class="far fa-calendar iconPanel font-13"></i>
												</button>
											</div>
										</div>
									</div>
								</div>

								<transition name="slide-up">
									<div v-show="modalConfig.transferencia == true" class="mt-3 col-12">
										<div>
											<label><i class="fas fa-user font-13 color-theme mr-1"></i><span class="font-14"> Selecione o capelão: </span></label>
											<v-select title="Desktop" :options="capeloes" v-model="modalConfig.transferenciaCapelao" label="capelaoNome" class="rounded"/>
											<select title="Mobile" class="form-control text-danger" v-model="modalConfig.transferenciaCapelao"> 
												<option v-for="(option, index) in capeloes" :key="index" :value="option">{{ option.capelaoNome }}</option>
											</select>
										</div>
										<div class="mt-2">
											<label><i class="fas fa-home font-13 color-theme mr-1"></i><span class="font-14"> Selecione a escola: </span></label>
											<v-select title="Desktop" :options="listaEscola" v-model="modalConfig.transferenciaDestino" label="nome" class="rounded"/>
											<select title="Mobile" class="form-control text-danger" v-model="modalConfig.transferenciaDestino"> 
												<option v-for="(option, index) in listaEscola" :key="index" :value="option">{{ option.nome }}</option>
											</select>
										</div>
										<div class="mt-3" v-if="modalConfig.transferenciaDestino != null && modalConfig.transferenciaCapelao != null">
											<button class=" btn btn-secondary w-100 rounded" @click="transferirAluno">
												<i class="fas fa-share-all font-13 mr-1"></i> Transferir
											</button>
										</div>
									</div>
								</transition>

								<transition name="slide-up">
									<div class="row" v-show="modalConfig.agendamento == true">
										<div class="col">
											<div class="col-12 mb-3 mt-3 input-group-lg">
												<label><i class="far fa-calendar color-theme font-13 mr-1 ml-1"></i> Agendar próximo encontro:</label>
												<input title="Mobile" class="form-control" type="date" v-model="modalConfig.agendamentoData" />
												<input title="Desktop" class="form-control" type="date" v-model="modalConfig.agendamentoData" />
											</div>
											<div class="input-group input-group-lg col-12 mb-3">
												<input type="time" class="form-control " value="13:30" v-model="modalConfig.agendamentoHora" >
											</div>
											<div class="col-12 mb-1">
												<button class="btn btn-secondary col-12 rounded" @click="enviarAgendamento(aluno.id)"><i class="far fa-calendar font-12 mr-1"></i> Agendar</button>
											</div>
										</div>
									</div>
								</transition>

								<hr class="ml-1 mr-1">

								<div class="row mb-0">
									<div class="col-12">
										<div class="form-group c_form_group c_form_group_deck p-2 mb-1 m-1">
											<label class="font-14">Adicionar Histórico</label>
											<div class="input-group">
												<textarea class="form-control" style="height: 60px;" v-model="modalConfig.novoHistorico"></textarea>
											</div>
										</div>
										<div class="form-group" v-show="modalConfig.novoHistorico != ''">
											<div class="input-group w-100">
												<div class="col-12 p-1">
													<button type="button" class="btn btn-primary btn-block p-0 rounded" @click="addHistorico">Adicionar</button>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div class="card-body p-1">
									<historico v-for="(historico, index) in historicos" :key="index" :historico="historico" :index="index" @deletar="deleteHistorico($event)" />
								</div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btnFechar rounded" @click="fecharPerfil">Fechar</button>
					</div>
				</div>
			</div>
		</div>
			
		<!-- modal editar -->
		<div class="fade modal" id="modalEditar" tabindex="-1" aria-labelledby="modalEditarLabel" data-backdrop="static" data-keyboard="false" aria-hidden="true">
			<div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title h4 color-theme"><span class="font-17">Editar</span></h5>
						<button type="button" class="close text-danger" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="row">
							<div class="card mb-0">
								<div class="card-body p-3">
									<div class="row" v-if="travaContinuar == 0">
										<div class="col-12 mb-3">
											<label><i class="far fa-user font-13 color-theme mr-1"></i><span class="font-14"> Nome completo: </span></label>
											<input type="text" class="form-control required rounded" maxlength="200" v-model="aluno.nomeCompleto" placeholder="Nome do usuário"/>  
										</div>
										<div class="col-12 mb-3">
											<label><i class="far fa-file-alt font-13 color-theme mr-1"></i><span class="font-14" > CPF: </span></label>
											<input type="text" class="form-control required rounded" maxlength="200" v-model="aluno.cpf"  placeholder="CPF do usuário" v-mask="'###.###.###-##'"/>  
										</div>
										<div class="col-12 mb-3">
											<label><i class="fas fa-birthday-cake font-13 color-theme mr-1"></i><span class="font-14"> Data de nascimento: </span></label>
											<input type="date" class="form-control rounded" maxlength="8" v-model="aluno.dataNascimento"/>
										</div>
										<div class="col-12  mb-3">
											<label><i class="fas fa-graduation-cap font-13 color-theme mr-1"></i><span class="font-14"> Escola: </span></label>
											<input disabled type="text" class="form-control required rounded" maxlength="200" v-model="aluno.nomeEscola" placeholder="Nome da escola" style="background-color: #222427 !important;"/>  
										</div>
										<div class="col-12  mb-3">
											<label><i class="fas fa-map-marker-alt font-13 color-theme mr-1"></i><span class="font-14"> Bairro: </span></label>
											<input type="text" class="form-control required rounded" maxlength="200" v-model="aluno.nomeBairro" placeholder="Nome do bairro"/>  
										</div>
										<div class="col-12  mb-3">
											<label><i class="fas fa-road font-13 color-theme mr-1"></i><span class="font-14"> Rua: </span></label>
											<input type="text" class="form-control required rounded" maxlength="200" v-model="aluno.nomeRua" placeholder="Nome da rua"/>  
										</div>
										<div class="col-12  mb-3">
											<label><i class="fas fa-map-pin font-13 color-theme mr-1"></i><span class="font-14"> Nº:</span></label>
											<input type="number" class="form-control required rounded" maxlength="200" v-model="aluno.numeroCasa" placeholder="Número da casa"/>  
										</div>
										<div class="col-12  mb-3">
											<label><i class="fas fa-mobile-alt font-13 color-theme mr-1"></i><span class="font-14"> Celular:</span></label>
											<input type="" class="form-control rounded" maxlength="16" v-model="aluno.celular" placeholder="(41) 9 0000-0000" v-mask="'(##) # ####-####'"/>
										</div>
										<div class="col-12 mb-3">
											<label><i class="fas fa-books font-13 color-theme mr-1"></i><span class="font-14"> Escolaridade: </span></label>
											<v-select title="Desktop" class="rounded" :options="['Ensino fundamental incompleto', 'Ensino fundamental completo', 'Ensino médio incompleto', 'Ensino médio completo', 'Ensino superior incompleto', 'Ensino superior completo','Pós graduação incompleto', 'Pós graduação completo']" v-model="aluno.escolaridade"/>
											<select title="Mobile" class="form-control rounded" v-model="aluno.escolaridade">
												<option v-for="(option, index) in ['Ensino fundamental incompleto', 'Ensino fundamental completo', 'Ensino médio incompleto', 'Ensino médio completo', 'Ensino superior incompleto', 'Ensino superior completo','Pós graduação incompleto', 'Pós graduação completo']" :key="index" :value="option">{{ option }}</option>
											</select>
										</div>
										<transition name="slide-up">
											<div class="col-12 mb-3 " v-if="aluno.escolaridade == 'Ensino superior incompleto' || aluno.escolaridade == 'Ensino superior completo' || aluno.escolaridade == 'Pós graduação incompleto' || aluno.escolaridade == 'Pós graduação completo'">
												<label><i class="far fa-graduation-cap font-13 color-theme mr-1 "></i><span class="font-14"> Graduação</span></label>
												<input type="text" class="form-control required rounded" maxlength="200" v-model="aluno.graduacao" placeholder="Digite aqui"/> 
											</div>
										</transition>
										<div class="col-12 mb-3">
											<label><i class="fas fa-heartbeat font-13 color-theme mr-1 "></i><span class="font-14"> Estado civil: </span></label>
											<v-select class="rounded" title="Desktop" :options="['Solteiro', 'Casado', 'Separado', 'Divorciado', 'Viúvo', 'Vivem juntos', 'Religioso']" v-model="aluno.estadoCivil"/>
											<select title="Mobile" class="form-control rounded" v-model="aluno.estadoCivil">
												<option v-for="(option, index) in ['Solteiro', 'Casado', 'Separado', 'Divorciado', 'Viúvo', 'Vivem juntos', 'Religioso']" :key="index" :value="option">{{ option }}</option>
											</select>
										</div>
										<transition name="slide-up">
											<div class="col-12 mb-3" v-if="aluno.estadoCivil == 'Casado'">
												<label><i class="fas fa-ring font-13 color-theme mr-1"></i><span class="font-14"> Casamento: </span></label>
												<v-select class="rounded" title="Desktop" :options="['Primeiro casamento','Segundo casamento','Terceiro casamento','Quarto casamento','Quinto casamento']" v-model="aluno.quantosCasamentos"/>
												<select title="Mobile" class="form-control rounded" v-model="aluno.quantosCasamentos">
													<option v-for="(option, index) in ['Primeiro casamento','Segundo casamento','Terceiro casamento','Quarto casamento','Quinto casamento']" :key="index" :value="option">{{ option }}</option>
												</select>
											</div>
										</transition>
										<transition name="slide-up ">
											<div class="col-12 p-0 mb-2" v-if="aluno.estadoCivil == 'Casado' && aluno.quantosCasamentos != 'Primeiro casamento'">
												<div class="col-12" v-for="(conjuge, index) in aluno.conjuges" :key="index">
													<label><i class="fas fa-user-tag font-13 color-theme mr-1"></i><span class="font-14"> Nome do cônjuge</span></label>
													<div>
														<input type="text" class="form-control required rounded" maxlength="200" v-model="conjuge.nome" placeholder="Nome completo do cônjuge"/>
														<input type="date" class="form-control required mt-1 mb-2 rounded" maxlength="200" v-model="conjuge.dataNascimento" placeholder="Nome completo do cônjuge"/>
														<input type="text" class="form-control required rounded" maxlength="200" v-model="conjuge.descricao" placeholder="Obs"/>
													</div>
												</div>
												<div class="row">
													<div class="col">
														<div class="col mt-3" v-if="travaBtn2 >= 1 && travaBtn2 < 15">
															<button class=" btn btn-secondary w-100 rounded rounded" @click="adicionarConjuge">
																<i class="fas fa-plus font-13  mr-1"></i> Adicionar
															</button>
														</div>
														<div class="col mt-3" v-if="travaBtn2 > 1">
															<button class=" btn btn-secondary w-100 rounded" @click="removerUltimoConjuge">
																<i class="fas fa-minus font-13 mr-1"></i> Remover
															</button>
														</div>
													</div>
												</div>
											</div>
										</transition>
										<transition name="slide-up">
											<div class="col-12 mb-3 " v-if="aluno.estadoCivil == 'Vivem juntos'">
												<label><i class="fas fa-user-friends font-13 color-theme mr-1"></i><span class="font-14"> Nome do amásio</span></label>
											<input type="text" class="form-control required rounded" maxlength="200" v-model="aluno.nomeConjuge" placeholder="Nome do amásio completo"/> 
											</div>
										</transition>
										<transition name="slide-up">
											<div class="col-12 mb-3 " v-if="aluno.estadoCivil == 'Vivem juntos'">
												<label><i class="fas fa-birthday-cake font-13 color-theme mr-1"></i><span class="font-14"> Data de nascimento do amásio</span></label>
												<input type="date" class="form-control required rounded" maxlength="200" v-model="aluno.dataNascimentoConjuge" placeholder="Data de nascimento do amásio"/> 
											</div>
										</transition>
										<div class="col-12 mb-3">
											<label><i class="far fa-baby font-13 color-theme mr-1"></i><span class="font-14"> Filhos: </span></label>
											<v-select title="Desktop" class="rounded" :options="['Não tem','Tem filhos',]" v-model="aluno.temFilhos"/>
											<select title="Mobile" class="form-control rounded" v-model="aluno.temFilhos">
												<option v-for="(option, index) in ['Não tem','Tem filhos',]" :key="index" :value="option">{{ option }}</option>
											</select>
										</div>
										<transition name="slide-up">
											<div class="col-12 p-0 mb-2" v-if="aluno.temFilhos == 'Tem filhos'">
												<filho v-for="(filho, index) in aluno.filhos" :key="index" :filho="filho" />

												<div class="row">
													<div class="col">
														<div class="col mt-3" v-if="travaBtn >= 1 && travaBtn < 15">
															<button class=" btn btn-secondary w-100 rounded" @click="adicionarFilho">
																<i class="fas fa-plus font-13 mr-1"></i> Adicionar
															</button>
														</div>
														<div class="col mt-3" v-if="travaBtn > 1">
															<button class=" btn btn-secondary w-100 rounded" @click="removerUltimoFilho">
																<i class="fas fa-minus font-13 mr-1"></i> Remover
															</button>
														</div>
													</div>
												</div>
											</div>
										</transition>
										<div class="col-12 mb-3">
											<label><i class="fas fa-home font-13 color-theme mr-1"></i><span class="font-14"> Mora com: </span></label>
											<v-select title="Desktop" class="rounded" :options="['Sozinho','Pais', 'Amigos','Cônjuge']" v-model="aluno.moradia"/>
											<select title="Mobile" class="form-control rounded" v-model="aluno.moradia">
												<option v-for="(option, index) in ['Sozinho','Pais', 'Amigos','Cônjuge']" :key="index" :value="option">{{ option }}</option>
											</select>
										</div>
										<div class="col-12 mb-3">
											<label><i class="fas fa-paste font-13 color-theme mr-1"></i><span class="font-14"> Possui casa: </span></label>
											<v-select title="Desktop" class="rounded" :options="['Cedida', 'Própria quitada', 'Própria financiada', 'Alugada']" v-model="aluno.possuiCasa"/>
											<select title="Mobile" class="form-control rounded" v-model="aluno.possuiCasa">
												<option v-for="(option, index) in ['Cedida', 'Própria quitada', 'Própria financiada', 'Alugada']" :key="index" :value="option" >{{ option }}</option>
											</select>
										</div>
										<transition name="slide-up">
											<div class="col-12 mb-3 " v-if="aluno.possuiCasa == 'Própria financiada' || aluno.possuiCasa == 'Alugada'">
												<label><i class="fas fa-dollar-sign font-13 color-theme mr-1"></i><span class="font-14"> Valor casa:</span></label>
												<input type="text" class="form-control required rounded" maxlength="200" v-model="aluno.valorCasa" placeholder="Valor e descrição opcional"/> 
											</div>
										</transition>
										<div class="col-12 mb-3">
											<label><i class="fas fa-car font-13 color-theme mr-1"></i><span class="font-14"> Possui veículo: </span></label>
											<v-select title="Desktop" class="rounded" :options="['Próprio quitado', 'Financiado', 'Não possui']" v-model="aluno.possuiVeiculo"/>
											<select title="Mobile" class="form-control rounded" v-model="aluno.possuiVeiculo">
												<option v-for="(option, index) in ['Não possui','Próprio quitado', 'Financiado',]" :key="index" :value="option">{{ option }}</option>
											</select>
										</div>
										<transition name="slide-up">
											<div class="col-12 mb-3 " v-if="aluno.possuiVeiculo == 'Financiado'">
												<label><i class="fas fa-dollar-sign font-13 color-theme mr-1"></i><span class="font-14"> Valor veículo:</span></label>
												<input type="text" class="form-control required rounded" maxlength="200" v-model="aluno.valorVeiculo" placeholder="Valor e descrição opcional"/> 
											</div>
										</transition>
									</div>

									<div v-else-if="travaContinuar == 1 || travaContinuar == 2 || travaContinuar == 4">
										<h3 class="d-flex align-center justify-content-center mb-4" v-if="travaContinuar == 1">Dados cadastrais</h3>
										<h3 class="d-flex align-center justify-content-center mb-4" v-else-if="travaContinuar == 2">Suas preferências</h3>
										<h3 class="d-flex align-center justify-content-center mb-4" v-else-if="travaContinuar == 4">Diagnóstico de estudo histórico das pessoas</h3>

										<div class="row">
											<pergunta v-for="(pergunta, index) in aluno.perguntas" :key="index" :pergunta="pergunta" :index="index" :travaContinuar="travaContinuar" />
										</div>
									</div>

									<div v-else-if="travaContinuar == 3">
										<h3 class="d-flex align-center justify-content-center mb-4">Diagnóstico do nível de estresse</h3>

										<div class="row">
											<diagnostico v-for="(diagnostico, index) in aluno.perguntas" :key="index" :travaContinuar="travaContinuar" :diagnostico="diagnostico" :index="index" @addPontuacao="addPontuacao($event)" />
										</div>
										<div class="mt-2 mb-2 col d-flex text-center ">
											<div class="col-6 justify-content-center">
												Total de pontos: {{resultado}}
											</div>
											<div class="col-6 justify-content-center">
												Itens selecionados: {{itensSelecionados}}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btnFechar rounded" data-dismiss="modal">Fechar</button>
						<button type="button" class="btn btn-primary rounded" @click="voltar" v-if="travaContinuar != 0">Voltar</button>
						<button type="button" class="btn btn-primary rounded" @click="continuar" v-if="travaContinuar != 4">Continuar</button>
						<button type="button" class="btn btn-primary rounded" @click="finalizar" v-else>Finalizar</button>
						
					</div>
				</div>
			</div>
		</div>

		<!-- Modal tela posCadastro -->
		<div class="modal fade" id="modalPosCadastro" tabindex="-1" aria-labelledby="modalPosCadastroLabel" data-backdrop="static" data-keyboard="false" aria-hidden="true">
			<div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title h4 color-theme"><span class="font-17">Pós Cadastro</span></h5>
						<button type="button" class="close text-danger" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
					</div>
					<div class="modal-body">
						<div class="card mb-0">
							<div class="card-body p-3">
								<h3 class="d-flex align-center justify-content-center">Avaliação da vida</h3>
								
								<pergunta class="semLimitador" v-for="(pergunta, index) in listaResposta.perguntas" :key="index" :pergunta="pergunta" :index="index" :travaContinuar="5" />
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btnFechar rounded" data-dismiss="modal">Fechar</button>
						<button type="button" class="btn btn-primary mr-1 rounded" @click="addPosPergunta(aluno.id)">Finalizar</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import Swal from 'sweetalert2'
import $ from 'jquery'
import { mapState } from 'vuex'
import { ptBR } from 'vuejs-datepicker/dist/locale'
import pergunta from '@/components/Pergunta.vue'
import aluno from '@/components/alunos/Aluno.vue'
import filho from '@/components/alunos/Filho.vue'
import historico from '@/components/alunos/Historico.vue'
import diagnostico from '@/components/alunos/Diagnostico.vue'

export default {
	name: 'Cadastros',
	data() {
		return {
			ptBR: ptBR,
			aluno: { celular: null, direcionado: null, conjuges: [], cpf: null, dataInscricao: null, dataNascimento: null, escolaridade: null, estadoCivil: null, filhos: [],
				graduacao: null, id: null, idAutor: null, idEscola: null, moradia: null, nomeAdm: null, dataAgendamento: null, nomeBairro: null, nomeCompleto: null, nomeEscola: null, nomeIgreja: null,
				nomeRua: null, numeroCasa: null, possuiCasa: null, possuiVeiculo: null, quantosCasamentos: null, resposta: [], valorVeiculo: null, valorCasa: null, temFilhos: null, posPerguntas: [], perguntas: []
			},
			listaAlunos: [],
			listaEscola: [],
			modalConfig: {'transferencia': false, 'agendamento': false, 'transferenciaDestino': null, 'transferenciaCapelao': null, 'agendamentoData': null, 'agendamentoHora': null, 'novoHistorico': ''},
			capeloes: [],
			historicos: [],
			travaBtn: 1,
			travaBtn2: 1,
			resultado: 0,
			itensSelecionados: 0,
			travaContinuar: 0,
			numeroResultados: 0,
			pagina: 0,
			pesquisa: {
				tipo: "Nome",
				valor: "",
				direcionado: 'Todos'
			},
			listaResposta: {
				idUsuario: '',
				perguntas: []
			},
		}
	},
	computed: {
		...mapState({
			urlRest: state => state.urlRest,
			dadosUsuario: state => state.dadosUsuario,
			dadosEscola: state => state.dadosEscola,
		})
	},
	components: {
		pergunta, aluno, historico, filho, diagnostico
	},
	methods: {
		pesquisarUsuario : function (pagina) {
			let ref = this;
			this.pagina = pagina == null ? ++this.pagina : pagina

			this.$store.dispatch('alternarTelaCarregamento', true)
			this.$axios({
				method: 'get',
				url: this.urlRest + 'service/getAluno',
				params: {
					tipo: this.pesquisa.tipo,
					comunidade: this.pesquisa.direcionado,
					valor: this.pesquisa.valor,
					data: this.pesquisa.data,
					id: this.dadosUsuario.usuarioId,
					admin: this.dadosUsuario.usuarioAdmin,
					idEscola: this.dadosEscola.id,
					pagina: this.pagina
				}
			}).then(response => {
				if (this.pagina == 0) {
               this.listaAlunos = []
            }
				ref.numeroResultados = response.data.total;

				response.data.lista.forEach(p => {
               this.listaAlunos.push(p)
            });

			}).catch(function (error) {
				if (error.response != undefined) {
					if (error.response.status == 408) {
						ref.$store.dispatch('deslogar')

						ref.$toast.fire({
							icon: 'warning',
							title: 'Sessão expirada!'
						});
					} else {
						ref.$toast.fire({
							icon: 'error',
							title: 'Erro: ' + error.response.status
						});
					}
				} else {
					ref.$toast.fire({
						icon: 'error',
						title: error
					});
				}
			}).finally(() => {
				this.$store.dispatch('alternarTelaCarregamento', false)
			});
		},
		getCapelao: function () {
			let ref = this;
			this.capeloes = []

			this.$store.dispatch('alternarTelaCarregamento', true)
			this.$axios({
				method: 'get',
				url: this.urlRest + 'service/getCapelao'

			}).then(response => {
				ref.capeloes = response.data;
				$('#modalCapelao').modal('show')

			}).catch(function (error) {
				if (error.response != undefined) {
					if (error.response.status == 408) {
						ref.$store.dispatch('deslogar')

						ref.$toast.fire({
							icon: 'warning',
							title: 'Sessão expirada!'
						});
					} else {
						ref.$toast.fire({
							icon: 'error',
							title: 'Erro: ' + error.response.status
						});
					}
				} else {
					ref.$toast.fire({
						icon: 'error',
						title: error
					});
				}
			}).finally(() => {
				this.$store.dispatch('alternarTelaCarregamento', false)
			});
		},
		getEscola() {
			let ref = this;

			this.$store.dispatch('alternarTelaCarregamento', true);
			this.$axios({
				method: 'get',
				url: this.urlRest +'service/getEscola',
			params: {
				valor: ''
			},
				headers: {
					'Content-Type': 'application/json'
				},

			}).then(response => {
			ref.listaEscola = response.data;

		}).catch(function (error) {
			if (error.response != undefined) {
				if (error.response.status == 408) {
					ref.$store.dispatch('deslogar')

					ref.$toast.fire({
							icon: 'warning',
							title: 'Sessão expirada!'
					});
				} else {
					ref.$toast.fire({
							icon: 'error',
							title: 'Erro: ' + error.response.status
					})
				}
				} else {
					ref.$toast.fire({
							icon: 'error',
							title: error
					})
				}
			}).finally(() => {
				this.$store.dispatch('alternarTelaCarregamento', false);
			});
		},
		abrirHistorico: function (idAluno) {
			let ref = this;

			this.$store.dispatch('alternarTelaCarregamento', true)
			this.$axios({
				method: 'get',
				url: this.urlRest + 'service/getHistorico',
				params: {
					id_aluno: idAluno
				}
			}).then(response => {
				ref.historicos = response.data;

			}).catch(function (error) {
				if (error.response != undefined) {
					if (error.response.status == 408) {
						ref.$store.dispatch('deslogar')

						ref.$toast.fire({
							icon: 'warning',
							title: 'Sessão expirada!'
						});
					} else {
						ref.$toast.fire({
							icon: 'error',
							title: 'Erro: ' + error.response.status
						});
					}
				} else {
					ref.$toast.fire({
						icon: 'error',
						title: error
					});
				}
			}).finally(() => {
				this.$store.dispatch('alternarTelaCarregamento', false)
			});
		},
		abrirAluno : function (aluno) {
			this.aluno = { nivel: aluno.nivel, celular: aluno.celular, direcionado: aluno.direcionado, conjuges: aluno.conjuges, cpf: aluno.cpf, dataInscricao: aluno.dataInscricao, 
				dataNascimento: this.formattedDate(aluno.dataNascimento), escolaridade: aluno.escolaridade, estadoCivil: aluno.estadoCivil, filhos: aluno.filhos, graduacao: aluno.graduacao, 
				id: aluno.id, idAutor: aluno.idAutor, idEscola: aluno.idEscola, moradia: aluno.moradia, nomeAdm: aluno.nomeAdm, dataAgendamento: aluno.dataAgendamento, nomeBairro: aluno.nomeBairro, nomeCompleto: aluno.nomeCompleto, 
				nomeEscola: aluno.nomeEscola, nomeIgreja: aluno.nomeIgreja, nomeRua: aluno.nomeRua, numeroCasa: aluno.numeroCasa, possuiCasa: aluno.possuiCasa, possuiVeiculo: aluno.possuiVeiculo, 
				quantosCasamentos: aluno.quantosCasamentos, resposta: aluno.resposta, temFilhos: aluno.temFilhos, valorVeiculo: aluno.valorVeiculo , valorCasa: aluno.valorCasa, posPerguntas: aluno.posPerguntas, perguntas: aluno.perguntas
			}

			this.abrirHistorico(aluno.id)
			this.getCapelao()
			this.getEscola()

			this.aluno.filhos.forEach(a => {
				a.dataNascimento = this.formattedDate(a.dataNascimento)
			});

			this.aluno.conjuges.forEach(a => {
				a.dataNascimento = this.formattedDate(a.dataNascimento)
			});

			$('#modalPerfil').modal('show')
		},
		fecharPerfil : function () {
			$('#modalPerfil').modal('hide')
			this.modalConfig.agendamento = false
			this.modalConfig.transferencia = false
			this.modalConfig.transferenciaDestino = null
			this.modalConfig.transferenciaCapelao = null
			this.modalConfig.agendamentoHora = null
			this.modalConfig.novoHistorico = ''
			this.atualizarData()
		},
		abrirEditar : function (aluno) {
			let ref = this;
			
			this.$axios({
				method: 'get',
				url: this.urlRest + 'service/getPerguntaResposta',
				params: {
					id: aluno.id
				}
			}).then(response => {
				ref.aluno.perguntas = response.data;
				ref.travaContinuar = 0;
				ref.resultado = aluno.nivel

				$('#modalEditar').modal('show')
			})
		},
		formattedDate(data) {
			if (!data) return null;

			const date = new Date(data);
			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, "0");
			const day = String(date.getDate()).padStart(2, "0");

			return `${year}-${month}-${day}`;
		},
		deleteHistorico : function (obj) {
			Swal.fire({
				icon: 'warning',
				title: 'Tem certeza que deseja deletar esse histórico?',
				confirmButtonText: 'Confirmar',
				showCancelButton: true,
				cancelButtonText: 'Cancelar'

			}).then((result) => {
				if (result.isConfirmed) {
					this.$axios({
						method: 'post',
						url: this.urlRest + 'service/deleteHistorico',
						params: {
							id: obj.id,
						}
					}).then(() => {
						this.historicos.splice(obj.index, 1)
					})
				}
			})
		},
		enviarAgendamento: function (idAluno) {
			let ref = this;

			if (ref.modalConfig.agendamentoHora != '') {
				this.$axios({
					method: 'post',
					url: this.urlRest + 'service/alterarData',
					params: {
						id_aluno: idAluno,
						data: ref.modalConfig.agendamentoData,
						hora: ref.modalConfig.agendamentoHora
					}

				}).then(function () {
					ref.$toast.fire({
						icon: 'success',
						title: 'Horário agendado!',
						timer: 1500
					})
					ref.atualizarData()
					$('#modalPerfil').modal('hide')
					ref.modalConfig.agendamentoHora = '13:00'
					ref.modalConfig.agendamento = false
					ref.pesquisarUsuario(0)
				});
			} else {
				ref.$toast.fire({
					icon: 'error',
					title: 'Defina um horário!',
					timer: 1500
				})
			}
		},
		addHistorico: function () {
			let ref = this;

			this.$store.dispatch('alternarTelaCarregamento', true)
			this.$axios({
				method: 'post',
				url: this.urlRest + 'service/addHistorico',
				headers: {
					'Content-Type': 'application/json'
				},
				data: {
					idAluno: this.aluno.id,
					texto: this.modalConfig.novoHistorico,
					autor: this.dadosUsuario.usuarioNome
				}
			}).then(function () {
				ref.modalConfig.novoHistorico = "";
				ref.getHistorico(ref.aluno.id)

			}).catch(function (error) {
				if (error.response != undefined) {
					if (error.response.status == 408) {
						ref.$store.dispatch('deslogar')

						ref.$toast.fire({
							icon: 'warning',
							title: 'Sessão expirada!'
						});
					} else {
						ref.$toast.fire({
							icon: 'error',
							title: 'Erro: ' + error.response.status
						})
					}
				} else {
					ref.$toast.fire({
						icon: 'error',
						title: error
					})
				}
			}).finally(() => {
				this.$store.dispatch('alternarTelaCarregamento', false);
			});
		},
		getHistorico: function (idAluno) {
			let ref = this;

			this.$axios({
				method: 'get',
				url: this.urlRest + 'service/getHistorico',
				params: {
					id_aluno: idAluno,
				}
			}).then(response => {
				ref.historicos = response.data;
			});
		},
		atualizarData : function () {
			const today = new Date();
			const tomorrow = new Date(today);
			tomorrow.setDate(today.getDate() + 1);
			this.modalConfig.agendamentoData = tomorrow.toISOString().substr(0, 10);
			this.modalConfig.agendamentoHora = '13:00';
			this.pesquisa.data = new Date().toISOString().substr(0, 10);
		},
		adicionarFilho : function () {
			this.aluno.filhos.push({ nome: null, nascimento: null });
			this.travaBtn += 1
		},
		removerUltimoFilho : function () {
			this.aluno.filhos.pop();
			this.travaBtn -= 1
		},
		adicionarConjuge : function () {
			this.aluno.conjuges.push({ nome: null, nascimento: null });
			this.travaBtn2 += 1
		},
		removerUltimoConjuge : function () {
			this.aluno.conjuges.pop();
			this.travaBtn2 -= 1
		},
		continuar : function () {
			this.travaContinuar = this.travaContinuar + 1
		},
		voltar : function () {
			this.travaContinuar = this.travaContinuar - 1
		},
		addPontuacao(pergunta) {
			let index = this.aluno.perguntas.findIndex(p => p.id == pergunta.id);

			if (pergunta.descricao != 'true') {
				pergunta.descricao = 'true';
				this.resultado = this.resultado + pergunta.nivel
				this.itensSelecionados += 1
			} else {
				pergunta.descricao = 'false';
				this.resultado = this.resultado - pergunta.nivel
				this.itensSelecionados -= 1
			}

			this.$set(this.aluno.perguntas, index, pergunta)
		},
		finalizar : function () {
			let ref = this;

			if (this.aluno.nomeCompleto != '') {
				this.$store.dispatch('alternarTelaCarregamento', true);
				this.$axios({
					method: 'post',
					url: this.urlRest +'service/adicionarAluno',
					headers: {
						'Content-Type': 'application/json'
					},
					data: this.aluno

				}).then(function () {
					ref.$toast.fire({
						icon: 'success',
						title: 'Cadastro atualizado!',
						timer: 1500,
					})

					ref.travaContinuar = 0
					$('#modalEditar').modal('hide')

				}).catch(function (error) {
					if (error.response != undefined) {
						if (error.response.status == 408) {
							ref.$store.dispatch('deslogar')

							ref.$toast.fire({
								icon: 'warning',
								title: 'Sessão expirada!'
							});
						} else {
							ref.$toast.fire({
								icon: 'error',
								title: 'Erro: ' + error.response.status
							})
						}
					} else {
						ref.$toast.fire({
							icon: 'error',
							title: error
						})
					}
				}).finally(() => {
					this.$store.dispatch('alternarTelaCarregamento', false);
				});
			} else {
				ref.$toast.fire({
					icon: 'error',
					title: 'Preencha o nome completo!',
					timer: 1500,
				});
				this.travaContinuar = 0
				this.$store.dispatch('alternarTelaCarregamento', false);
			}
		},
		transferirAluno : function () {
			let ref = this;

			this.$store.dispatch('alternarTelaCarregamento', true)
			this.$axios({
				method: 'post',
				url: this.urlRest + 'service/editCapelao',
				params: {
					capelaoId: this.modalConfig.transferenciaCapelao.capelaoId,
					capelaoNome: this.modalConfig.transferenciaCapelao.capelaoNome,
					escolaId: this.modalConfig.transferenciaDestino.id,
					escolaNome: this.modalConfig.transferenciaDestino.nome,
					usuarioId: this.aluno.id
				}
			}).then(response => {
				ref.capeloes = response.data;
				
				Swal.fire({
					icon: 'warning',
					title: 'Tem certeza que deseja transferir esse cadastro?',
					confirmButtonText: 'Confirmar',
					showCancelButton: true,
					cancelButtonText: 'Cancelar'

				}).then((result) => {
					if (result.isConfirmed) {
						ref.$toast.fire({
							icon: 'success',
							title: 'Transferido!',
							timer: 1500,
						});

						$('#modalPerfil').modal('hide')

						this.modalConfig.transferencia = false;
						this.modalConfig.transferenciaDestino = null;
						this.modalConfig.transferenciaCapelao = null;
						this.pesquisarUsuario(0)
					}
				})
			}).catch(function (error) {
				if (error.response != undefined) {
					if (error.response.status == 408) {
						ref.$store.dispatch('deslogar')

						ref.$toast.fire({
							icon: 'warning',
							title: 'Sessão expirada!'
						});
					} else if (error.response.status == 400) {
						ref.$toast.fire({
							icon: 'warning',
							title: 'O aluno não pode ser transferido para um capelão que não tem acesso a esta escola'
						});
					} else {
						ref.$toast.fire({
							icon: 'error',
							title: 'Erro: ' + error.response.status
						});
					}
				} else {
					ref.$toast.fire({
						icon: 'error',
						title: error
					});
				}
			}).finally(() => {
				this.$store.dispatch('alternarTelaCarregamento', false)
			});
		},	
		posCadastro : function (aluno) {
			let ref = this;

			this.$axios({
				method: 'get',
				url: this.urlRest +'service/getPerguntaResposta',
				params: {
					tela: 5,
					id: aluno.id
				}			
			}).then(response => {
				ref.listaResposta.perguntas = response.data;
				$('#modalPosCadastro').modal('show')
			})

		},
		addPosPergunta(idAluno) {
			let ref = this;
			ref.listaResposta.idUsuario = idAluno

			this.$axios({
				method: 'post',
				url: this.urlRest +'service/addPosPergunta',
				headers: {
					'Content-Type': 'application/json'
				},
				data: this.listaResposta
		
			}).then(response => {
				ref.aluno.posPerguntas = response.data;
				$('#modalPosCadastro').modal('hide')

				ref.$toast.fire({
					icon: 'success',
					title: 'Salvo com sucesso!',
					timer: 1500,
				})
			})
		},
		deletarAluno : function (obj) {
			Swal.fire({
				icon: 'warning',
				title: 'Tem certeza que deseja deletar esse aluno?',
				confirmButtonText: 'Confirmar',
				showCancelButton: true,
				cancelButtonText: 'Cancelar'

			}).then((result) => {
				if (result.isConfirmed) {
					this.$axios({
						method: 'post',
						url: this.urlRest + 'service/deletarAluno',
						params: {
							id: obj.id
						}
					}).then(() => {
						this.listaAlunos.splice(obj.index, 1)
					})
				}
			})
		}
	},
	mounted() {
		this.atualizarData();
		this.pesquisarUsuario(0);
	}
}

</script>

<style scoped>

input[type="date"]::-webkit-calendar-picker-indicator {
   filter: invert(50%);
}

.unicoLimitador {
	overflow: hidden !important;
	display: -webkit-box !important;
	-webkit-line-clamp: 1 !important;
	-webkit-box-orient: vertical !important;
	line-break: anywhere !important;
}

.btnFechar {
	color: white;
	background-color: #616161;
}

.btnPanel:hover {
	background-color: #0392CF;
	color: rgb(255, 255, 255);
	border: solid rgb(255, 255, 255) 1px;
}

.btnPanel {
	background-color: #0392CF;
	color: rgb(255, 255, 255)
}

input[type="time"]::-webkit-calendar-picker-indicator{
  filter: invert(48%) sepia(13%) saturate(0%) hue-rotate(130deg) brightness(95%) contrast(80%);
}

</style>